import { useTRPC } from "../../trpc";
import { IconChevronRight, IconExclamationCircle } from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";
import { captureEvent } from "../../utils/posthog";
import { useSetUser, useUser } from "../../hooks/user";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Event } from "../../constants/events";
import { useNavigateUserAuth } from "./hooks/navigate";
import {
  Alert,
  NavLink,
  Stack,
  Title,
} from "@mantine/core";
import { useEffect } from "react";
import { Loader } from "../../components/Loader";

export function SelectAccount() {
  const navigate = useNavigateUserAuth();
  const user = useUser();
  const trpc = useTRPC();
  const setUser = useSetUser();

  const { data, isLoading, error } = useQuery(trpc.getCurrentUser.queryOptions(undefined, {
    enabled: !user,
  }));

  useEffect(() => {
    if (!user && data) {
      setUser(data);
    }
  }, [user, data, setUser, navigate]);

  const { mutate } = useMutation(
    trpc.switchAccount.mutationOptions({
      onSuccess: (userWithAccountSelected) => {
        setUser(userWithAccountSelected);
        navigate(userWithAccountSelected);
      },
    }),
  );

  return (
    <Stack>
      {isLoading && (
        <Stack gap={16}>
          <Loader />
        </Stack>
      )}
      {error && (
        <Stack gap={16}>
          <Alert color="red" icon={<IconExclamationCircle />}>
            <Title size="h3">
              <FormattedMessage id="title.userNotAuthenticated" defaultMessage="User not authenticated" />
            </Title>
          </Alert>
        </Stack>
      )}
      {user && (
        <Stack gap={16}>
          <Title size="h3">
            <FormattedMessage id="title.selectAccount" defaultMessage="Select account" />
          </Title>
          {user.accounts.map(account => (
            <NavLink
              variant="light"
              label={account.displayName}
              key={account.id}
              onClick={() => {
                captureEvent(Event.AuthSelectedAccount);
                mutate(account);
              }}
              rightSection={<IconChevronRight size="1rem" stroke={1.5} />}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
